export default __webpack_public_path__ + "static/media/GB-SCT.bf634ebb.svg";